import React, { Dispatch, SetStateAction } from 'react';

import { UseQueryResult } from '@tanstack/react-query';
import { Empty, Spin as AntdSpin } from 'antd';

import { useBaseFormContext } from '../BaseFormContext';
import { setFieldValue } from '../utils';

import BaseSelect, { BaseSelectProps } from './BaseSelect';

interface BaseSelectWithQueryProps<FormValues, OptionType>
  extends Omit<BaseSelectProps<FormValues, OptionType>, 'options'> {
  query: UseQueryResult<OptionType[]>;
  additionalOptions?: OptionType[];
  setSearched: Dispatch<SetStateAction<string>>;
}

export default function BaseSelectWithQuery<FormValues, OptionType>({
  query,
  setSearched,
  additionalOptions,
  ...props
}: BaseSelectWithQueryProps<FormValues, OptionType>): React.ReactElement {
  const form = useBaseFormContext<FormValues>();
  function searchHandler(value: string) {
    setSearched(value);
  }

  return (
    <BaseSelect
      {...props}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        if (option && props.id) {
          setFieldValue(form, props.id, option);
        }
      }}
      showSearch={true}
      options={[...(additionalOptions ?? []), ...(query.data ?? [])]}
      dropdownMatchSelectWidth={350}
      onSearch={searchHandler}
      notFoundContent={query.isFetching ? <AntdSpin size="small" /> : <Empty />}
    />
  );
}
